// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html{
    height: 100%;
    width: 100%;
}

body {
	height: 100%;
}

#root {
    height: 100%;
}

.cmsd-login-input {
    width: 100%;
    max-width: none;
    border: 1px solid #aeb0b9;
}

#avp-login-screen {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;    
	/* background: url(/public/images/login_bkg.jpg); */
	background-repeat: no-repeat;
    background-size: cover;
}

#avp-login-screen-content {
    margin-right: auto;
    margin-left: auto;
}


#avp-login-screen-body-header {
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 3vh;
}

#avp-login-screen-body-header-title {
    font-family: Open Sans;
    font-size: 34px;
	color: black;
    font-weight: 700;
    line-height: 43.52px;
	color :"black";
    text-align: center;
}

#avp-login-screen-body-header-subtitle {
    font-family: Open Sans;
    font-size: 20px;
    font-weight: 600;
    line-height: 31.6px;
    letter-spacing: 0.0075em;
    text-align: center;
    color: #D2D2D2;

}

.avp-login-logo-container{
	text-align: center;
	margin-top: 25px;
}

.avp-login-form-container{
	width: 100%;
	max-width: 350px;
  	height: 425px;	
  	background: #ffffff;
  	/*padding: 68px 55px;*/
  	margin: 0 auto;
    border-radius: 10px;
}

.avp-login-form-title{
	text-align: center;
	font-size: 17px;
	font-weight: 600;
}

.avp-login-label{
	color: #808080;
	margin-bottom: 2px;
}

.avp-login-hide-password{
	position: absolute;
	bottom: 8px;
    right: 15px;
}

.avp-login-elemento{
	position: relative;
	margin-top: 19px;
}

.avp-login-input{
	width: 100%;
	max-width: none;
	border: 1px solid #aeb0b9;
}

.avp-login-input.notvalid {
	width: 100%;
	max-width: none;
	border: 1px solid #FFD54F;
}

.avp-login-button{
	width: 100%;
	max-width: none;
	height: 50px;
	font-size: 15px;

    color: #ffffff;
    border: none;
    border-radius: 25px;
    outline: none;
    background-color: #FFD54F;
    padding-left: 15px;
    padding-right: 15px;
}

.avp-login-form-content{
	padding: 0 20px;
}

.avp-login-form{
	width: 100%;
	height: 100%;
	padding: 25px;
}

#avp-login-errore{
	height: 20px;
}

#avp-login-passwordlost {
    text-align: center;
    text-decoration: underline;
    color: #CD1404;
    cursor: pointer;
}

#avp-login-passwordlost a {
    color: #CD1404;
}

.avp-login-elemento .avp-login-password-dimenticata{
	text-decoration: underline;
}

.avp-login-password-dimenticata:hover{
	text-decoration: underline;
}



@media screen and (max-width: 1199px) and (min-width: 992px){

}



@media screen and (max-width: 991px) and (min-width: 768px){

}



@media screen and (max-width: 767px) and (min-width: 576px){
  
}



@media only screen and (max-width: 575px){
 	.avp-login-form-container{
 		width: 90%;
    	max-width: none;
    	height: 100%;
    	margin-top: 25px;
    	padding: 0;
    	background-size: 100% 100%;
    	background: #ffffff;
 	}	

 	.avp-login-form-content{
 		padding: 0;
 	}
}


`, "",{"version":3,"sources":["webpack://./src/login/login.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;CACf,mDAAmD;CACnD,4BAA4B;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;;AAGA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,eAAe;CAClB,YAAY;IACT,gBAAgB;IAChB,oBAAoB;CACvB,cAAc;IACX,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;;AAElB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,gBAAgB;GACd,aAAa;GACb,mBAAmB;GACnB,sBAAsB;GACtB,cAAc;IACb,mBAAmB;AACvB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;IACR,WAAW;AACf;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,eAAe;;IAEZ,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,YAAY;AACb;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;;;AAIA;;AAEA;;;;AAIA;;AAEA;;;;AAIA;;AAEA;;;;AAIA;EACE;GACC,UAAU;KACR,eAAe;KACf,YAAY;KACZ,gBAAgB;KAChB,UAAU;KACV,0BAA0B;KAC1B,mBAAmB;EACtB;;EAEA;GACC,UAAU;EACX;AACF","sourcesContent":["html{\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\nbody {\r\n\theight: 100%;\r\n}\r\n\r\n#root {\r\n    height: 100%;\r\n}\r\n\r\n.cmsd-login-input {\r\n    width: 100%;\r\n    max-width: none;\r\n    border: 1px solid #aeb0b9;\r\n}\r\n\r\n#avp-login-screen {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;    \r\n\t/* background: url(/public/images/login_bkg.jpg); */\r\n\tbackground-repeat: no-repeat;\r\n    background-size: cover;\r\n}\r\n\r\n#avp-login-screen-content {\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n}\r\n\r\n\r\n#avp-login-screen-body-header {\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    margin-bottom: 3vh;\r\n}\r\n\r\n#avp-login-screen-body-header-title {\r\n    font-family: Open Sans;\r\n    font-size: 34px;\r\n\tcolor: black;\r\n    font-weight: 700;\r\n    line-height: 43.52px;\r\n\tcolor :\"black\";\r\n    text-align: center;\r\n}\r\n\r\n#avp-login-screen-body-header-subtitle {\r\n    font-family: Open Sans;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    line-height: 31.6px;\r\n    letter-spacing: 0.0075em;\r\n    text-align: center;\r\n    color: #D2D2D2;\r\n\r\n}\r\n\r\n.avp-login-logo-container{\r\n\ttext-align: center;\r\n\tmargin-top: 25px;\r\n}\r\n\r\n.avp-login-form-container{\r\n\twidth: 100%;\r\n\tmax-width: 350px;\r\n  \theight: 425px;\t\r\n  \tbackground: #ffffff;\r\n  \t/*padding: 68px 55px;*/\r\n  \tmargin: 0 auto;\r\n    border-radius: 10px;\r\n}\r\n\r\n.avp-login-form-title{\r\n\ttext-align: center;\r\n\tfont-size: 17px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.avp-login-label{\r\n\tcolor: #808080;\r\n\tmargin-bottom: 2px;\r\n}\r\n\r\n.avp-login-hide-password{\r\n\tposition: absolute;\r\n\tbottom: 8px;\r\n    right: 15px;\r\n}\r\n\r\n.avp-login-elemento{\r\n\tposition: relative;\r\n\tmargin-top: 19px;\r\n}\r\n\r\n.avp-login-input{\r\n\twidth: 100%;\r\n\tmax-width: none;\r\n\tborder: 1px solid #aeb0b9;\r\n}\r\n\r\n.avp-login-input.notvalid {\r\n\twidth: 100%;\r\n\tmax-width: none;\r\n\tborder: 1px solid #FFD54F;\r\n}\r\n\r\n.avp-login-button{\r\n\twidth: 100%;\r\n\tmax-width: none;\r\n\theight: 50px;\r\n\tfont-size: 15px;\r\n\r\n    color: #ffffff;\r\n    border: none;\r\n    border-radius: 25px;\r\n    outline: none;\r\n    background-color: #FFD54F;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n}\r\n\r\n.avp-login-form-content{\r\n\tpadding: 0 20px;\r\n}\r\n\r\n.avp-login-form{\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tpadding: 25px;\r\n}\r\n\r\n#avp-login-errore{\r\n\theight: 20px;\r\n}\r\n\r\n#avp-login-passwordlost {\r\n    text-align: center;\r\n    text-decoration: underline;\r\n    color: #CD1404;\r\n    cursor: pointer;\r\n}\r\n\r\n#avp-login-passwordlost a {\r\n    color: #CD1404;\r\n}\r\n\r\n.avp-login-elemento .avp-login-password-dimenticata{\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.avp-login-password-dimenticata:hover{\r\n\ttext-decoration: underline;\r\n}\r\n\r\n\r\n\r\n@media screen and (max-width: 1199px) and (min-width: 992px){\r\n\r\n}\r\n\r\n\r\n\r\n@media screen and (max-width: 991px) and (min-width: 768px){\r\n\r\n}\r\n\r\n\r\n\r\n@media screen and (max-width: 767px) and (min-width: 576px){\r\n  \r\n}\r\n\r\n\r\n\r\n@media only screen and (max-width: 575px){\r\n \t.avp-login-form-container{\r\n \t\twidth: 90%;\r\n    \tmax-width: none;\r\n    \theight: 100%;\r\n    \tmargin-top: 25px;\r\n    \tpadding: 0;\r\n    \tbackground-size: 100% 100%;\r\n    \tbackground: #ffffff;\r\n \t}\t\r\n\r\n \t.avp-login-form-content{\r\n \t\tpadding: 0;\r\n \t}\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
